import * as classnames from 'classnames'
import * as React from 'react'
import * as styles from './hostedHeaderStyles.module.css'

import { config } from '../../../../common/config'
import Modal from '../modals'

import InfoIcon from '../icons/info'

interface IProps {
  children: any
  wide?: boolean
  openModal: (data: any) => any
}

const HostedHeader = ({ children, wide, openModal }: IProps) => {
  const containerClass = classnames(styles.headerWrapper, {
    [styles.wideSearchPageHeader]: wide
  })

  const onClickMoreInfo = () => {
    openModal({ type: 'hostedMoreInfo' })
  }

  return (
    <div className={styles.container}>
      <div className={containerClass}>
        <div className={styles.headingWrapper}>
          <div className={styles.heading}>
            Your favourite WordPress Themes with Setup and Managed Hosting
          </div>
          <div className={styles.subheading}>
            Envato Hosted is the all in one WordPress solution. Choose from our
            selection of themes, then let our experts take care of setup,
            support and managed hosting.
            <button className={styles.moreInfoLink} onClick={onClickMoreInfo}>
              <InfoIcon className={styles.infoIcon} />
            </button>
          </div>
        </div>
        <div className={styles.iconTextWrapper}>
          <div className={styles.iconColumnWrapper}>
            <div className={styles.iconWrapper}>
              <img
                alt={''}
                role="presentation"
                className={styles.icon}
                src={`${config.assets.PUBLIC_PATH}/images/hosted/diamond.svg`}
              />
            </div>
            <div className={styles.iconText}>
              Premium ThemeForest&nbsp;
              <br className={styles.lineBreak} />
              theme &amp; installation
            </div>
          </div>
          <div className={styles.iconColumnWrapper}>
            <div className={styles.iconWrapper}>
              <img
                alt={''}
                role="presentation"
                className={styles.icon}
                src={`${config.assets.PUBLIC_PATH}/images/hosted/document.svg`}
              />
            </div>
            <div className={styles.iconText}>
              Managed&nbsp;
              <br className={styles.lineBreak} />
              WordPress Hosting
            </div>
          </div>
          <div className={styles.iconColumnWrapper}>
            <div className={styles.iconWrapper}>
              <img
                alt={''}
                role="presentation"
                className={styles.icon}
                src={`${config.assets.PUBLIC_PATH}/images/hosted/support.svg`}
              />
            </div>
            <div className={styles.iconText}>
              Premium Technical&nbsp;
              <br className={styles.lineBreak} />
              Support
            </div>
          </div>
          <div className={styles.iconColumnWrapper}>
            <div className={styles.iconWrapper}>
              <img
                alt={''}
                role="presentation"
                className={styles.icon}
                src={`${config.assets.PUBLIC_PATH}/images/hosted/backups.svg`}
              />
            </div>
            <div className={styles.iconText}>
              Backups &amp; WordPress&nbsp;
              <br className={styles.lineBreak} />
              updates
            </div>
          </div>
          <div className={styles.iconColumnWrapper}>
            <div className={styles.iconWrapper}>
              <img
                alt={''}
                role="presentation"
                className={styles.icon}
                src={`${config.assets.PUBLIC_PATH}/images/hosted/www.svg`}
              />
            </div>
            <div className={styles.iconText}>
              Domain purchase&nbsp;
              <br className={styles.lineBreak} />
              available
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}

export default HostedHeader
